import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  constructor(private readonly swUpdate: SwUpdate) {
  }

  init(): void {
    if (!this.swUpdate.isEnabled) {
      return;
    }

    // A stale cached bundle otherwise keeps running old auth code against the
    // current backend (e.g. pre-BFF-migration JS calling the new cookie-based API).
    this.swUpdate.available.subscribe(() => {
      this.swUpdate.activateUpdate().then(() => window.location.reload());
    });

    this.swUpdate.unrecoverable.subscribe(() => window.location.reload());
  }
}
